/** `YYYY-MM-DD` obligatorio, `THH:mm` opcional. */
const SALE_START_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/

/**
 * Formatea la fecha de apertura de venta (`sale_start`) como
 * "01/11/2026 a las 21:00" — numérica, con año y hora, según el diseño nuevo de
 * la ficha (Figma «Aún no disponible»). Antes era "12 de septiembre": sin año
 * ni hora, una apertura a meses vista quedaba ambigua.
 *
 * Extrae los segmentos del inicio de la cadena sin construir un
 * `Date`/`Intl.DateTimeFormat`, mismo criterio que `formatEventDate` para
 * evitar el desplazamiento de día y de hora (research.md §4: el ISO ya trae el
 * offset del negocio, así que lo que está escrito en la cadena ya es la fecha y
 * la hora correctas de cara al usuario).
 *
 * La hora es opcional a propósito: si el backend manda solo `YYYY-MM-DD`, se
 * devuelve la fecha sola en vez de `null` — devolver `null` haría que
 * `resolvePurchaseState` cayera al estado por defecto y habilitara la compra de
 * un evento que todavía no está a la venta.
 */
export function formatPurchaseDate(iso: string): string | null {
  const match = SALE_START_PATTERN.exec(iso)
  if (!match) return null
  const [, year, month, day, hours, minutes] = match
  if (!year || !month || !day) return null

  const date = `${day}/${month}/${year}`
  return hours && minutes ? `${date} a las ${hours}:${minutes}` : date
}
